"use-strict";

export const APP_DATA_KEY = "APP_DATA_KEY";
export const ORG_ID_KEY = "ORG_ID_KEY";
export const BRAND_ID_KEY = "BRAND_ID_KEY";
export const DEVICE_TOKEN = "DEVICE_TOKEN";
export const AUTH_TOKEN_KEY = "AUTH_TOKEN_KEY";
export const IN_PROGRESS_INFLUENCER_IDS = "IN_PROGRESS_INFLUENCER_IDS";
export const CAMPAIGN_FILTERS_KEY = "CAMPAIGN_FILTERS_KEY";

/** Persists add-influencer profile sync `batch_id` for a collection until batch sync completes (JSON). */
export const ADD_INFLUENCER_BATCH_SYNC_KEY = (collectionId) =>
  `ADD_INFLUENCER_BATCH_SYNC_${String(collectionId)}`;
